module.exports = __webpack_public_path__ + "static/media/female.9f9f1f8c.svg";